var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultFaviconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192.000000 192.000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        .icon {\n          fill: #fff;\n        }\n    ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,192.000000) scale(0.100000,-0.100000)",
    className: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M840 1844 c-156 -28 -269 -72 -385 -149 -309 -205 -458 -599 -365 -960 109 -427 527 -716 960 -665 418 50 738 367 790 786 45 355 -150 723 -471 889 -130 67 -240 96 -384 100 -66 2 -131 2 -145 -1z m164 -182 c3 -5 2 -41 -1 -80 l-6 -71 -41 -6 c-144 -24 -248 -137 -250 -271 -1 -78 12 -88 99 -78 124 14 196 10 242 -14 60 -31 73 -55 73 -133 0 -37 3 -75 6 -84 12 -30 60 -45 142 -45 123 0 227 38 331 120 62 49 71 44 71 -35 0 -119 -42 -272 -102 -372 -18 -30 -59 -84 -91 -119 -178 -195 -453 -275 -709 -206 -72 20 -75 26 -77 140 l-1 73 174 -7 174 -7 12 44 c27 98 -14 192 -113 266 -119 88 -117 87 -422 93 l-270 5 -3 69 c-4 97 22 216 69 315 98 207 273 348 494 396 68 15 191 19 199 7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultFaviconDark);
export default __webpack_public_path__ + "static/media/default-favicon-dark.8d67fe915c44a205b0153eba262af2d4.svg";
export { ForwardRef as ReactComponent };